import { render, staticRenderFns } from "./SidebarButton.vue?vue&type=template&id=44da9d31&scoped=true"
import script from "./SidebarButton.vue?vue&type=script&lang=js"
export * from "./SidebarButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44da9d31",
  null
  
)

export default component.exports